(function (jQuery) {
	"use strict";

	function ShowCharacterCount() {
		var fn = {
			init: function() {
				jQuery('[data-showcharactercount]').each(fn.initElement);
				jQuery('[data-showcharactercount]').on('change keyup keydown input', fn.onChange);
			},

			initElement: function() {
				const parent = jQuery(this).parents('.text-field');
				const max = jQuery(this).attr('maxlength');
				const counter = jQuery('<p class="showcharactercount"><span class="showcharactercount__count"></span> / <span class="showcharactercount__max">10</span> characters</p>');
				counter.find('.showcharactercount__max').text(max);
				parent.append(counter);
				fn.onChange.bind(this)();
			},

			onChange: function() {
				const chars = this.value.length;
				const countEl = jQuery(this).parents('.text-field').find('.showcharactercount__count');
				countEl.text(chars);
			}
		}

		jQuery(fn.init);
	}

	new ShowCharacterCount();
})(jQuery);